import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
  } from '@/components/ui/alert-dialog';
  import { useQueryClient } from '@tanstack/react-query';
  
  export type DeleteAccountReceivableConfirmationProps = {
    isOpen: boolean;
    handleOpen: (boolean: boolean) => void;
    scorelogicId: string;
  };
  
  export const DeleteScoreLogicConfirmation = ({
    isOpen,
    handleOpen,
    scorelogicId,
  }: DeleteAccountReceivableConfirmationProps) => {
    const queryClient = useQueryClient();
    const params = $router.get()?.params as Record<'organizationId', string>;
    const [deletingScoreLogic, setDeletingScoreLogic] = useState(false);
  
    return (
      <AlertDialog open={isOpen} onOpenChange={handleOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
            <AlertDialogDescription>
              This action cannot be undone. This will permanently delete this
              account receivable and remove all the data inside it from our servers.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={async e => {
                e.preventDefault();
                setDeletingScoreLogic(true);
                await deleteScoreLogic(params.organizationId ?? '', scorelogicId);
                setDeletingScoreLogic(false);
                handleOpen(false);
              }}
              disabled={deletingScoreLogic}
              className="bg-red-600 hover:bg-red-500 dark:text-white dark:hover:bg-red-700"
            >
              {deletingScoreLogic ? 'Processing...' : 'Continue'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    );
};
    